export function csrfToken() {
  if (typeof document === 'undefined') return ''
  return document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || ''
}

export function syncCsrfToken(token) {
  if (!token || typeof document === 'undefined') return
  const meta = document.querySelector('meta[name="csrf-token"]')
  if (meta) meta.setAttribute('content', token)
}

function withCsrfToken(options, token = csrfToken()) {
  const headers = new Headers(options.headers || {})
  if (token) headers.set('X-CSRF-Token', token)
  return { credentials: 'same-origin', ...options, headers }
}

export async function csrfFetch(input, options = {}) {
  const response = await fetch(input, withCsrfToken(options))
  if (response.status !== 422) return response

  const payload = await response.clone().json().catch(() => ({}))
  if (payload.error !== 'invalid_csrf') return response

  const freshToken = response.headers.get('X-CSRF-Token')
  if (!freshToken) return response

  syncCsrfToken(freshToken)
  return fetch(input, withCsrfToken(options, freshToken))
}
